import { useEffect, useMemo, useState } from 'react';
import { convertCssToPixels } from '@govinity/ui/lib/utils';

/**
 * Hook to detect current screen size breakpoint
 * @returns 'xs' for mobile (< 768px), 'md' for tablet (768-1023px), 'lg' for desktop (>= 1024px)
 */
export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState<'xs' | 'md' | 'lg'>('xs');

  const breakpoints = useMemo(() => {
    const styles = getComputedStyle(document.documentElement);
    return {
      sm: styles.getPropertyValue('--breakpoint-sm').trim() || '640px',
      md: styles.getPropertyValue('--breakpoint-md').trim() || '768px',
    };
  }, []);

  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      const smPixels = convertCssToPixels(breakpoints.sm);
      const mdPixels = convertCssToPixels(breakpoints.md);

      if (width < smPixels) {
        setScreenSize('xs');
      } else if (width < mdPixels) {
        setScreenSize('md');
      } else {
        setScreenSize('lg');
      }
    };

    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, [breakpoints]);

  return screenSize;
};
